import React from 'react';
import CustomPaper from "../../../../shared/utils/CustomPaper";
import AuthService from '../../../../../services/AuthService';
import ReactTable from "react-table";
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import moment from '../../../../shared/utils/moment_fr';
import reactTableProps from '../../../../shared/utils/reactTableProps';
import OptionBtn from './EntretienOptionsBtnComponent';
import pdfHandler from "../../../../shared/utils/pdfHandler";
import Alert from "../../../../shared/utils/Alert";
import {connect} from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import SalarieService from "../../../../salarie/services/SalarieService";


class PasserEntretien extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            entretiens: [],
            selected_salarie: {id: 0}
        };
        this.Auth = new AuthService();
        this.salarieService = new SalarieService();
        this.downloadFile = this.downloadFile.bind(this);
        this.startEntretien = this.startEntretien.bind(this);
        this.getOpenedEntretiens = this.getOpenedEntretiens.bind(this);
    }

    startEntretien(id_salarie) {
        const x = this.state.entretiens.map(s => s.id_salarie).indexOf(id_salarie);
        if (x > -1) {
            const ent = this.state.entretiens[x];
            alert("Il y'a actuellement un entretien en attente de signature pour le salarié: " +
                ent.nom + " " + ent.prenom + "\n" +
                "Veuillez Reprendre l'entretien ou le supprimer dans le tableau ci-dessus.");
        } else {
            this.Auth.fetch('/societe/entretien',
                {
                    method: 'post',
                    data: {
                        date_heure: moment().unix(),
                        id_salarie: id_salarie
                    }
                }).then(resp => {
                const id_entretien = resp.data.payload;
                this.props.history.push('/entreprise/passer_entretien/' + id_entretien + '/1')
            });
        }
    }

    componentDidMount() {
        this.getOpenedEntretiens();
    }

    getOpenedEntretiens() {
        this.Auth.fetch('/societe/opened_entretiens')
            .then(resp => this.setState({entretiens: resp.data.payload}));
    }

    downloadFile(id) {
        this.Auth.fetch(`/services/pdf/entretien/${id}?is_apercu=true`, {responseType: 'arraybuffer'})
            .then(resp => pdfHandler(resp.data, 'apreçu_entretien_professionnel.pdf'));
    }


    render() {
        const salaries = [];
        this.props.salaries.map(x => salaries.push(<MenuItem key={x.id} value={x.id}
                                                             primaryText={x.nom + " " + x.prenom}/>));

        return (
            <div>
                <CustomPaper title="Entretiens en attente de signature">
                    <ReactTable

                        filterable
                        defaultFilterMethod={(filter, row) => {
                            let row_value = row[filter.id].toUpperCase();
                            let filter_value = filter.value.toUpperCase();
                            return (row_value.indexOf(filter_value) > -1);
                        }
                        }
                        {...reactTableProps}
                        data={this.state.entretiens.filter(e => e.is_accepted_by_entreprise === '1')}
                        columns=
                            {
                                [
                                    {
                                        Header: "Salarié",
                                        columns: [
                                            {
                                                Header: "Numéro",
                                                accessor: "num_salarie",
                                                maxWidth: 80
                                            },
                                            {
                                                Header: "Nom",
                                                accessor: "nom",
                                                maxWidth: 120
                                            },
                                            {
                                                Header: "Prénom",
                                                accessor: "prenom",
                                                maxWidth: 120
                                            },
                                        ]
                                    }, {
                                    Header: "Entretien",
                                    maxWidth: 500,
                                    columns: [
                                        {
                                            Header: "Type",
                                            accessor: "type",
                                            maxWidth: 300,
                                            Filter: ({filter, onChange}) =>
                                                <select
                                                    onChange={event => onChange(event.target.value)}
                                                    style={{width: "100%"}}
                                                    value={filter ? filter.value : ''}
                                                >
                                                    <option key={999} value=''>Tous les types</option>
                                                    {this.props.params_types_entretien.map(
                                                        e => <option key={e.id} value={e.type}>{e.type}</option>
                                                    )}
                                                </select>
                                        },
                                        {
                                            Header: "Date de l'entretien",
                                            accessor: "date_heure",
                                            filterable: false,
                                            Cell: row => (
                                                <div>
                                                    {moment(row.value).format('llll')}
                                                </div>),
                                            maxWidth: 200
                                        },
                                        {
                                            Header: "Options",
                                            filterable: false,
                                            sortable: false,
                                            accessor: "id",
                                            Cell: row => (
                                                <OptionBtn
                                                    onClick1={() => this.props.history.push('/entreprise/passer_entretien/' + row.value + '/1')}
                                                    onClick2={() => this.downloadFile(row.value)}
                                                    onClick3={() => {
                                                        if (window.confirm('Voulez vous vraiment supprimer l\'entretien sélectionné ? \nToutes les données liées à l\'entretien seront perdues.')) {
                                                            this.Auth.fetch('/societe/entretien/' + row.value, {method: 'delete'})
                                                                .then(resp => {
                                                                    window.alert('Entretien supprimé avec succès.');
                                                                    this.getOpenedEntretiens()
                                                                });
                                                        }
                                                    }}
                                                />

                                            )
                                        }
                                    ]
                                }
                                ]}
                        defaultPageSize={5}
                        className="-striped -highlight"
                    />
                </CustomPaper>
                <CustomPaper title='Commencer un entretien immédiat'>
                    <SelectField
                        value={null}
                        floatingLabelText='Salarié'
                        onChange={(x, y, z) => this.startEntretien(z)}
                        maxHeight={400}
                    >
                        {salaries}
                    </SelectField>
                </CustomPaper><br/>
                {
                    this.state.entretiens.filter(e => e.is_accepted_by_entreprise !== '1').length > 0 &&
                    <CustomPaper title='Entretiens proposés par les salariés'>
                        <Alert
                            text="Ici vous trouvez les entretiens proposés par les salariés, veuillez les confirmer ou les refuser."/>


                        <table className="table">
                            <thead>
                            <tr>
                                <th scope="col">Numéro</th>
                                <th scope="col">Nom</th>
                                <th scope="col">Prénom</th>
                                <th scope="col">Date</th>
                                <th scope="col">Accepter</th>
                                <th scope="col">Refuser</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.entretiens.filter(e => e.is_accepted_by_entreprise !== '1')
                                    .map(e =>
                                        <tr key={e.id}>
                                            <td>{e.num_salarie}</td>
                                            <td>{e.nom}</td>
                                            <td>{e.prenom}</td>
                                            <td>{moment(e.date_heure).format('llll')}</td>
                                            <td>
                                                {
                                                    e.is_accepted_by_entreprise !== '2' ? 'Refusé' :
                                                        <RaisedButton secondary={true}
                                                                      label='Acceper'
                                                                      onClick={() => this.acceptEntretien(e, true)}
                                                        />
                                                }</td>
                                            <td>
                                                {
                                                    e.is_accepted_by_entreprise !== '2' ? 'Refusé' :
                                                        <RaisedButton label='Refuser'
                                                                      backgroundColor='#FFFF00 '
                                                                      onClick={() => this.acceptEntretien(e, false)}
                                                                      labelColor='#000000'/>
                                                }</td>
                                        </tr>)
                            }
                            </tbody>
                        </table>
                    </CustomPaper>
                }
            </div>
        );
    }

    acceptEntretien(e, t) {
        this.salarieService.acceptEntretien({id_entretien: e.id, is_accepted: t ? '1' : '0'})
            .then(() => {
                this.getOpenedEntretiens();
                alert('Entretien ' +
                    (t ? 'Accepté.' : 'Refusé.')
                );
            });
    }
}

function mapStateToProps(store) {
    return {
        params_types_entretien: store.params.types_entretien,
        salaries: store.entreprise.entreprise_infos.salaries
    }
}

export default connect(mapStateToProps)(PasserEntretien);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/_index.js